/*
 * File: form-any.ts
 * File Created: 2024-09-04 05:38:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-19 08:57:33
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { UITag } from "@root/core/tags";
import { CreateElement } from "vue";

/// iv-form-any: accept anything and respond anything.
/// used for a property that provide generated data.
@Component
export default class FormAny extends BaseFormComponent {
    render(h: CreateElement) {
        return this.$slots.default;
    }
}
